import {$controller} from "rapid/index";
import {delay, forEach, clone} from "lodash";

const dependencies = ["$Company", "$Users"];


export default class Controller extends $controller {
    constructor($injector, $scope, $state, $stateParams, $window, $ToastService) {
        "ngInject";
        super($injector, dependencies);
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$window = $window;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.selectedFilter = {};
        this.$scope.companies = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.toastService = $ToastService;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };

        let managers;
        managers = this.$Users.query({groups: 2});
        managers && managers.$promise
            .then((managers) => {
                this.$scope.managers = managers;
            }).catch((e) => {
                console.log(e);
                this.$state.go("clients");
            });
    }

    $onInit() {
        this.$scope.selectFilter = {show: false};
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        if (this.$stateParams.createdCompany) {
            const confirm = this.$mdDialog.confirm()
                .title(`Company ${this.$stateParams.createdCompany} created`)
                .textContent("Would you like to invite company admin?")
                .ariaLabel("Confirm")
                .ok("Yes")
                .cancel("Invite later");

            this.$mdDialog.show(confirm).then(() => {
                this.$state.go("users", {"createdCompany": this.$stateParams.createdCompany});
            }, () => {
                // $scope.status = 'You decided to keep your debt.';
                this.$state.go("clients");
            });
        }
        document.addEventListener("keypress", this.searchByKeyPress);
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);
    }

    query(isNew) {
        this.$scope.query.page = isNew ? 1 : this.$scope.query.page;

        this.$Company.query(this.$scope.query).$promise.then((c) => {
            this.$scope.loading = false;

            isNew ? this.$scope.companies = c : this.$scope.companies.push(...c);
            this.$scope.pageCount = c._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;
        }).catch(() => {
            this.toastService.showError("Can't load clients", 5000);
        });
    }

    transformClientsArr(arr, title) {
        let newArr = [];
        forEach(arr, (user) => {
           newArr.push(`${user.first_name} ${user.last_name}`);
        });
        let str = newArr.length > 1 ? newArr.join(title ? "\n": ", ") : newArr.join("");
        return (str.length > 25 && !title) ? `${str.slice(0,25)} ...` : str;
    }

    removeFilter() {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);
    }

    setFilter() {
        this.$scope.query.page = 1;
        this.$scope.query.status = this.$scope.selectFilter.status || null;
        this.$scope.query.client_type = this.$scope.selectFilter.client_type || null;
        this.$scope.query.managers = this.$scope.selectFilter.managers || null;
        this.query(true);
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    openInNewTab(id) {
        this.$window.open(this.$window.location.href + "settings/" + id, "_blank");
    }
}


// WEBPACK FOOTER //
// ./sources/components/clients/client-list/client-list.controller.js